module.exports = "/static/assets/66be91f1b84761d9f350dbf0c8844a0d.png";